var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputWrapper',{attrs:{"labelTag":"div","label":_vm.label}},[_c('div',{staticClass:"invite-email-box"},[_c('EmailIcon',{attrs:{"width":"24","height":"24","color":"currentColor"}}),_c('span',[_vm._v(_vm._s(_vm.email))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }